import { z } from 'zod';

export const ControlVariableDataType = z
  .enum(['numeric', 'categorical'])
  .describe('ControlVariableDataType');
export type ControlVariableDataType = z.infer<typeof ControlVariableDataType>;

export const ControlVariableDataTypes = Object.values(
  ControlVariableDataType.Values,
);
